import { gql } from '@apollo/client';
import { BuildingFragment } from '../EditBuilding';

export const SITE_FRAGMENT = gql`
  fragment SiteFragment on Site {
    id
    name
    customID
    timezone
  }
`;

export const CREATE_SITE_MUTATION = gql`
  mutation createSite($input: CreateSiteInput!) {
    createSite(input: $input) {
      site {
        ...SiteFragment
      }
    }
  }
  ${SITE_FRAGMENT}
`;

export const CREATE_BUILDING_MUTATION = gql`
  mutation createBuilding($input: CreateBuildingInput!) {
    createBuilding(input: $input) {
      building {
        ...BuildingFragment
      }
    }
  }
  ${BuildingFragment}
`;

export interface CreateSiteInput {
  name: string;
  customID?: string;
  timezone: string;
}

export interface CreateBuildingInput {
  name: string;
  customID?: string;
  siteId: string;
  buildingNumber?: string;
  address?: {
    lines: string[];
    country: string;
  };
  capacity?: {
    max?: number;
    mid?: number;
  };
}
